module.exports = __webpack_public_path__ + "static/Plaak - 33-Pradel-Regular-205TF-bd15b8ad04ace27544c1c334b0bd3289.woff2";